import type { RSheetColumn, RSheetRecordNode } from '../../../../domain/column.ts'
import { RSheetsCellBooleanInput } from './input/BooleanInputCell'
import { RSheetsCellDateInput } from './input/DateInputCell'
import { RSheetsCellDateTimeInput } from './input/DateTimeInputCell'
import { RSheetsCellMultiSelectOptionInput } from './input/MultiSelectOptionInputCell'
import { RSheetsCellNumberInput } from './input/NumberInputCell'
import { RSheetsCellRelationInput } from './input/RelationInputCell'
import { RSheetsCellSelectOptionInput } from './input/SelectOptionInputCell'
import { RSheetsCellStirngInput } from './input/StirngInputCell'
import { RSheetsCellTimeInput } from './input/TimeInputCell'
import type { RSheetsCellInputRenderTypeArgument } from './rSheetsCellInputRenderTypeArgument'

export function InputCell(
  argument: RSheetsCellInputRenderTypeArgument & { columns: Array<RSheetColumn<RSheetRecordNode>> },
) {
  const { column, recordNode } = argument
  // 虫眼鏡セルの場合
  if (recordNode === undefined && column.nodeType === 'parent') {
    return <RSheetsCellRelationInput {...argument} emptyCell />
  }
  // 参照カラムの場合（column.field.fieldMetaType でないことに注意）
  if (column.metaType === 'relation') {
    return <RSheetsCellRelationInput {...argument} />
  }

  if ((column.selectOptions ?? []).length > 0) {
    if (column.metaType === 'multi_select') {
      return <RSheetsCellMultiSelectOptionInput {...argument} />
    }
    return <RSheetsCellSelectOptionInput {...argument} />
  }

  switch (column.type) {
    case 'integer' as const: {
      return <RSheetsCellNumberInput {...argument} />
    }
    case 'numeric' as const: {
      return <RSheetsCellNumberInput {...argument} />
    }
    case 'date' as const: {
      return <RSheetsCellDateInput {...argument} />
    }
    case 'datetime' as const: {
      return <RSheetsCellDateTimeInput {...argument} />
    }
    case 'time' as const: {
      return <RSheetsCellTimeInput {...argument} />
    }
    case 'boolean' as const: {
      return <RSheetsCellBooleanInput {...argument} />
    }
    default: {
      return <RSheetsCellStirngInput {...argument} />
    }
  }
}
